<style scoped>

  .ui.button {
    width: 130px;
  }

</style>

<template>

  <div id="cancel-dialog" class="ui small modal cancel-modal">

    <div class="ui header">
      Cancelamento de Orçamento
    </div>

    <div class="content">

      <form class="ui form">        
        <div class="fields">
          <div class="sixteen wide field">        
            <label class="form-label">Motivo <span class="red text">*</span></label>
            <select id="select-reason" class="ui fluid dropdown" v-model="reason">
                <option value="">Selecione...</option>
                <option value="01">CLIENTE DESISTIU</option>
                <option value="02">CLIENTE FECHOU COM UM CONCORRENTE</option>
                <option value="99">OUTRO MOTIVO</option>
            </select>  
          </div> 
        </div>
        <div class="fields">
          <div class="sixteen wide field">        
            <label class="form-label">
              Observações <span v-if="reason == '99'" class="red text animated flash">*</span>
            </label>
            <input type="text" v-model="comments">
          </div> 
        </div>
      </form> 

      <div class="ui orange message">
        <i class="exclamation circle icon"></i> Essa operação é irreversível
      </div> 

    </div>

    <div class="actions">
      <button class="ui cancel basic button">
        <i class="reply icon"></i>
        Sair
      </button>
      <button type="button" class="ui basic red button"  @click="onCancel()">
        <i class="times icon"></i>
        Cancelar
      </button>      
    </div>

  </div>

</template>

<script>

  import Message from "@/utils/message"

  export default {

    data() {
      return {
        reason: "",
        comments: "",
      }
    },

    props: ["quotation"],  

    mounted() {
      $("#select-reason").dropdown()
    },

    beforeDestroy() {
      $(".cancel-modal").remove()
    },
    
    methods: {

      show() {
        $("#cancel-dialog").modal("show")        
      },

      hide() {
        $("#cancel-dialog").modal("hide")
      },

      async onCancel() {

        if (!this.validCancel())
          return

        this.$emit("onCancel", { reason: this.reason, comments: this.comments })

        this.hide()
      },

      validCancel() {

        let isOk = true
        let message = ""

        if (!this.reason) {

          message = "Informe o motivo do cancelamento"

        } else if (this.reason == "99" && !this.comments) {

          message = "Informe alguma observação sobre o motivo do cancelamento"
        }

        if (message) {
          isOk = false
          Message.info(message)
        }

        return isOk
      },
    },
  }

</script>

